import { call, put } from 'redux-saga/effects';
import {
  deleteExcelTaxRateFailure,
  deleteExcelTaxRateSuccess,
} from '../actions';
import { deleteExcelTaxRate } from '../api';
import { DeleteExcelTaxRateRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import { saveTaxRatesSuccess } from 'store/tax-rates/actions';
import { updateOrganisationTaxRates } from 'store/organisation/actions';
import { getTaxRates, GetTaxRatesResponse } from 'store/returns/api';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* deleteExcelTaxRateSaga(
  action: DeleteExcelTaxRateRequestAction
) {
  try {
    const { connectionId, taxRateId } = action.payload;

    const response: ApiResponse = yield call(
      deleteExcelTaxRate,
      connectionId,
      taxRateId
    );

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(deleteExcelTaxRateSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Refresh tax rates only for this connectionId and update organisation slice.
    // Support both legacy `{ data: { taxRates, taxEnabled, connectionId } }`
    // and newer `{ taxRates, taxEnabled, connectionId }` response shapes.
    const taxRatesResponse: GetTaxRatesResponse = yield call(
      getTaxRates,
      connectionId
    );
    const inner: any =
      (taxRatesResponse as any)?.data ?? (taxRatesResponse as any);
    const freshTaxRates = inner?.taxRates ?? [];
    const freshTaxEnabled = inner?.taxEnabled ?? false;

    yield put(saveTaxRatesSuccess(freshTaxRates, connectionId));
    yield put(
      updateOrganisationTaxRates(
        connectionId,
        freshTaxRates,
        freshTaxEnabled,
        freshTaxRates
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteExcelTaxRateFailure());
  }
}

